module.exports = __webpack_public_path__ + "fonts/1f662a8.ttf";